'use strict';

exports.__esModule = true;
exports.Chip = undefined;

var _Chip2 = require('./Chip');

var _Chip3 = _interopRequireDefault(_Chip2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Chip3.default;
exports.Chip = _Chip3.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/Chips/index.js
// module id = 846
// module chunks = 168707334958949